module.exports = __webpack_public_path__ + "media/images/ui__arrowLeft-4199825e858c26313734da5c8219d861.png";